import React__default, { useCallback } from 'react';
import { Icon } from '@sravni/react-design-system/lib/Icon';
import { Space } from '@sravni/react-design-system/lib/Space';
import { Link, Text } from '@sravni/react-design-system/lib/Typography';
import { Logout } from '@sravni/react-icons';
import { useAuthLogoutLink } from '@sravni/react-utils';
import { useAnalyticEvents } from '../../../hooks/useAnalyticEvents.js';
import '../../Providers/CustomPropsProvider/src/CustomPropsProvider.js';
import { useCustomProps } from '../../Providers/CustomPropsProvider/hooks/useCustomProps.js';

const LogoutButton = (props) => {
    const { onClick, ...rest } = props;
    const { pushAnalyticEvent } = useAnalyticEvents();
    const { oidcHandlerPrefix } = useCustomProps();
    const authLogoutLinkProps = useAuthLogoutLink({ prefix: oidcHandlerPrefix, isNewWindow: false });
    const handleClick = useCallback((event) => {
        onClick?.(event);
        pushAnalyticEvent("logout" /* EVENTS.LOGOUT */);
    }, [onClick, pushAnalyticEvent]);
    return (React__default.createElement(Link, { color: "gray", ...authLogoutLinkProps, ...rest, onClick: handleClick },
        React__default.createElement(Space, { align: "center", size: 12 },
            React__default.createElement(Icon, { icon: React__default.createElement(Logout, null) }),
            React__default.createElement(Text, { size: 16, strong: true, className: "h-color-D60" }, "\u0412\u044B\u0439\u0442\u0438"))));
};
LogoutButton.displayName = 'LogoutButton';

export { LogoutButton };
//# sourceMappingURL=LogoutButton.js.map
